var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dot
    ? _c(
        "span",
        { ref: "badge", class: _vm.classes },
        [
          _vm._t("default"),
          _vm._v(" "),
          _c("sup", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.badge,
                expression: "badge"
              }
            ],
            class: _vm.dotClasses,
            style: _vm.styles
          })
        ],
        2
      )
    : _vm.status || _vm.color
    ? _c(
        "span",
        { ref: "badge", staticClass: "ivu-badge-status", class: _vm.classes },
        [
          _c("span", { class: _vm.statusClasses, style: _vm.statusStyles }),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "ivu-badge-status-text" },
            [
              _vm._t("text", function() {
                return [_vm._v(_vm._s(_vm.text))]
              })
            ],
            2
          )
        ]
      )
    : _c(
        "span",
        { ref: "badge", class: _vm.classes },
        [
          _vm._t("default"),
          _vm._v(" "),
          _vm.$slots.count
            ? _c(
                "sup",
                { class: _vm.customCountClasses, style: _vm.styles },
                [_vm._t("count")],
                2
              )
            : _vm.hasCount
            ? _c(
                "sup",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.badge,
                      expression: "badge"
                    }
                  ],
                  class: _vm.countClasses,
                  style: _vm.styles
                },
                [
                  _vm._t("text", function() {
                    return [_vm._v(_vm._s(_vm.finalCount))]
                  })
                ],
                2
              )
            : _vm._e()
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-216c3b0d", { render: render, staticRenderFns: staticRenderFns })
  }
}